import {
	baseUrl,
	ssoUrl,
	wechatUrl,
	cdoUrl,
	appUrl,
	cvoUrl,
	cdnUrl,
	versionUrl,
} from './env'
import axios from 'axios';
import store from '../store/'
import Vue from 'vue'
import util from './util'
// axios.defaults.withCredentials=true

//定义API mock 切换
export const sconfig={
	all:false,
	common:false,
	enroll:false,
	order:false,
	vo:false,
}

export const SSO='SSO';
export const WECHAT='WECHAT';
export const APP = 'APP';
export const CVO = 'CVO';
 /** 
  * 代替原来的fetch方法，原方法在Mac下会报错。
  */
export const fetch = (type = 'GET', url = '', uid, method, params = {},domain) => {
	let withCredentials = false;
	let headers = {
		'Authorization-Token': uid || '',
		'Authorization-Method': method,
	}
	if (domain === SSO) {
		url = ssoUrl + url;
		headers = {};
	}else if (domain === WECHAT) {
		url = cdoUrl + url;
		url += `${url.indexOf('?') == -1 ? '?':'&'}channel=MyO`
	} else if(domain === APP){
		url = appUrl + url
	} else if(domain === CVO){
		url = cvoUrl + url;
		headers = {};
	} else if(domain === 'Newframework' ) {
		url = wechatUrl + url;

	}
	else {
		url = baseUrl + url;
	}
	if(domain != WECHAT){
		url += `${url.indexOf('?') == -1 ? '?':'&'}channel=WebSite`
	}
	// 格式化URL，params
	url = formatURL(url)
	params = formatParams(params)
	if(type == 'GET'){
		return axios.get(url, { params: params,withCredentials, headers}).then(res => {
			if(res.status !== 200) {
				return null;
			} else {
				if (res.data?.response?.time) {
					window.time = res.data.response.time;
				}
				window.basetime = new Date();
				checkUser(res.data,url)
				return res.data;
			}
		}).catch((error) => {
			if (error && error.message && error.message.useCache) {
				return error.message.data.data
			}
			if(error.response && error.response.status == '400' || error.response.status == '429' || error.response.status == '503'){
				Vue.prototype.$Message.error({
					content: `当前购物高峰期人数较多，请您稍后再试`,
					duration: 5,
				});
			}
			return null;
		});
	}
	else if(type == 'POST'){
		let param = { paramss: params,withCredentials}
		if (domain == 'Newframework') {
			param = {...params,withCredentials}
		}
		return axios.post(url, param, {headers}).then(res => {
			if(res.status !== 200) {
				return null;
			} else {
				if (res.data?.response?.time) {
					window.time = res.data.response.time;
				}
				window.basetime = new Date();
				checkUser(res.data,url)
				return res.data;
			}
		}).catch((error) => {
			console.log('error:' + error);
			if(error.response && error.response.status == '400' || error.response.status == '429' || error.response.status == '503'){
				Vue.prototype.$Message.error({
					content: `当前购物高峰期人数较多，请您稍后再试`,
					duration: 5,
				});
			}
			return null;
		});
	}
}
function formatURL(url){
	return url.replace(/null|undefined/g,matched=>{
		return ''
	})
}
function formatParams(params){
	for (let value in params) {
		if (params[value] == null || params[value] == undefined)params[value] = ''
		
	}
	return params
}

function getQueryString(url,name) {
	var reg = new RegExp("(^|\\?|&)" + name + "=([^&]*)(\\s|&|$)", "i");
	if (reg.test(url)) return unescape(RegExp.$2.replace(/\+/g, " "));
	return null;
}

function checkUser(res,url){

	if(res&&res.response&&res.response.code==-1&&res.response.errorCode=='0005'){
		var m=getQueryString(url,'m')
		if(m=='so002'||m=='MI_01'||m=='Home_08'){
			return 
		}
		store.dispatch('setConfigKeyAction','userInfo')
		//location.reload();
		let redirect;
		let toUrl = Vue.prototype.$path
		let regex = /token=\w*(&|$)|(\?|&)token=\w*$/;
		toUrl = toUrl.replace(regex, "");
		if (process.env.NODE_ENV === 'development') {
			redirect = escape(`http://localhost:8080/#${toUrl}`);
			location.href = `${ssoUrl}/sso/index.html#/login?redirect=${redirect}`;
		} else {
			redirect = escape(`${baseUrl}/vo/index.html#${toUrl}`);
			location.href = `${ssoUrl}/sso/index.html#/login?redirect=${redirect}`;
		}
	}
}


/**
 * 创建临时数据
 */
export const setpromise = data => {
	return new Promise((resolve, reject) => {
		resolve(data)
	})
};
/**
 * doTERRA 通用API接口
 */
export const fetchForDoterra = (type = 'GET', method, token, uid, params = {},lastPath='app_api') => {
	return fetch(type, `/api/v1/${lastPath}?version=` + process.env.VUE_APP_VERSION + '&token=' + token + '&m=' + method + '&uid=' + uid, uid, method, params);
};
export const fetchForCVO = (type = 'GET', method, token, VipNo, params = {}) => {
	return fetch(type, '/api/v1/client_api?version=' + process.env.VUE_APP_VERSION + '&token=' + token + '&m=' + method + '&VipNo=' + VipNo, token, method, params, CVO);
};
export const fetchForDoterraNoLogin = (type = 'GET', method, token, VipNo, params = {}, domain) => {
	return fetch(type, '/api/v1/app_api?version=' + process.env.VUE_APP_VERSION + '&token=' + token + '&m=' + method + '&VipNo=' + VipNo, token, method, params, domain);
};

export const fetchForDoterraWX = (type = 'GET', method, token, uid, params = {}) => {
    return fetch(type, '/api/v1/client_api?version=' + process.env.VUE_APP_VERSION + '&token=' + token + '&m=' + method + '&uid=' + uid, uid, method, params, WECHAT);
}

export const fetchForAPP = (type = 'GET', method, token, uid, params = {}) => {
    return fetch(type, '/api/v1/app_api?version=' + process.env.VUE_APP_VERSION + '&token=' + token + '&m=' + method + '&uid=' + uid, uid, method, params,APP);
}

export const fetchForCDN = async (type = 'GET',method,token,uid,params,sourceFetch,forceCDN=false) => {
	if (store.getters.useCDN || forceCDN) {
		let path = Object.values(params).filter(item=>item).join('/')
		let url = `${cdnUrl}/website/${method}/${path}`
		return axios.get(url, {
			withCredentials:false,
			headers:{
				'cache-control': 'no-cache'
			}
		}).then(res => {
			if(res.status !== 200) {
				return null;
			} else {
				checkUser(res.data,url)
				return res.data;
			}
		}).catch((error) => {
			return null;
		});
	} else {
		sourceFetch = sourceFetch || fetchForDoterra
		return sourceFetch(type,method,token,uid,params)
	}
	
}

export const checkVersion = async () => {
	return axios.get(versionUrl, {
		withCredentials:false,
		headers:{
			'cache-control': 'no-cache'
		}
	}).then(res => {
		console.log(res)
		if (res.data != process.env.VUE_APP_VERSION && process.env.VUE_APP_INNERNODE_ENV != 'development') {
	 		location.reload()
	 	}
	})
}
